import type { ThemeConfig } from 'antd';

import lightTheme from './light.json';

export const adaptDesignTokensToAntd = (): ThemeConfig => {
  return {
    // В antd 6 cssVar принимает только объект; пустой объект включает CSS-переменные с дефолтным префиксом "ant"
    cssVar: {},
    token: {
      colorPrimary: lightTheme.token['brand.6'],
      colorSuccess: lightTheme.token['green.6'],
      colorWarning: '#faad14',
      colorError: '#ff4d4f',
      colorInfo: lightTheme.token.colorInfo,
      colorText: lightTheme.token.colorText,
      colorTextSecondary: lightTheme.token.colorTextSecondary,
      colorTextTertiary: lightTheme.token.colorTextTertiary,
      colorTextQuaternary: lightTheme.token.colorTextQuaternary,
      colorBgMask: lightTheme.token.colorBgMask,
      colorBgSpotlight: lightTheme.token.colorBgSpotlight,
      colorPrimaryBorder: lightTheme.token['brand.3'],
      colorBorder: lightTheme.token.colorBorder,
      colorBorderSecondary: lightTheme.token.colorBorderSecondary,
      colorFill: lightTheme.token.colorFill,
      colorFillSecondary: lightTheme.token.colorFillSecondary,
      colorFillTertiary: lightTheme.token.colorFillTertiary,
      colorFillQuaternary: lightTheme.token.colorFillQuaternary,
      colorSplit: lightTheme.token.colorSplit,
      fontFamily: lightTheme.token.fontFamily,
      fontSize: 14,
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSizeXL: 20,
      borderRadius: 6,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      controlHeight: lightTheme.token.controlHeight,
      controlHeightSM: lightTheme.token.controlHeightSM,
      controlHeightLG: lightTheme.token.controlHeightLG,
      padding: 16,
      paddingSM: 12,
      paddingLG: 24,
      paddingXS: 8,
    },
    components: {
      Button: {
        borderRadius: 6,
        controlHeight: lightTheme.token.controlHeight,
        paddingInlineSM: lightTheme.components.Button.paddingInlineSM,
        paddingInlineLG: lightTheme.components.Button.paddingInlineLG,
        paddingInline: lightTheme.components.Button.paddingInline,
      },
      Input: {
        borderRadius: 6,
        controlHeight: lightTheme.token.controlHeight,
      },
      Select: {
        borderRadius: 6,
        controlHeight: lightTheme.token.controlHeight,
      },
      Card: {
        borderRadius: 8,
      },
      Modal: {
        borderRadius: 8,
      },
      FloatButton: {
        sizePopupArrow: lightTheme.components.FloatButton.sizePopupArrow,
        paddingXS: lightTheme.components.FloatButton.paddingXS,
        marginXXS: lightTheme.components.FloatButton.marginXXS,
        marginXS: lightTheme.components.FloatButton.marginXS,
        lineWidthFocus: lightTheme.components.FloatButton.lineWidthFocus,
        controlPaddingHorizontal: lightTheme.components.FloatButton.controlPaddingHorizontal,
        controlItemBgActiveHover: lightTheme.components.FloatButton.controlItemBgActiveHover,
        controlItemBgActive: lightTheme.components.FloatButton.controlItemBgActive,
        controlHeight: lightTheme.components.FloatButton.controlHeight,
        borderRadiusXS: lightTheme.components.FloatButton.borderRadiusXS,
        colorTextDisabled: lightTheme.components.FloatButton.colorTextDisabled,
        colorTextDescription: lightTheme.components.FloatButton.colorTextDescription,
        colorPrimaryBorder: lightTheme.components.FloatButton.colorPrimaryBorder,
        colorError: lightTheme.components.FloatButton.colorError,
      },
      Spin: {
        // Маппинг размеров Antd Spin на legacy UI Kit Loader:
        // small -> s (24), default -> m (54), large -> l (100)
        // TODO: Поменяем на нужные значения позже, когда определимся какие размеры у лоадеров должны быть в новом дизайне
        dotSizeSM: 24,
        dotSize: 54,
        dotSizeLG: 100,
      },
      Menu: lightTheme.components.Menu,
    },
  };
};
